module.exports = __webpack_public_path__ + "img/loginBg.a129f11d.jpg";